var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdownar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20711 6H4H6.79289C7.23835 6 7.46143 6.53857 7.14645 6.85355L4 10L0.853553 6.85355C0.538571 6.53857 0.761654 6 1.20711 6Z",
    fill: "#FF8D1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79289 4L4 4L1.20711 4C0.761654 4 0.53857 3.46143 0.853552 3.14645L4 0L7.14645 3.14645C7.46143 3.46143 7.23835 4 6.79289 4Z",
    fill: "#FF8D1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdownar);
export default __webpack_public_path__ + "static/media/updownar.c551f122287624fd4ebd0b2ee81f3ebc.svg";
export { ForwardRef as ReactComponent };